export const TRACKING_ACTION_TYPES = {
  TRACK: 'track'
};
